(function () {
    'use strict';

    angular
        .module('app')
        .component('nivelEducativoListPublic', {
            templateUrl: 'app/components/auladigital/public/nivel-educativo-list.public.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                niveles: '<'
            }
        });

    /* @ngInject */
    function Controller() {

    }

})();
